export enum DepositFlowType {
	CHECKOUT_FLOW = "1",
	MARGIN_TRADING_FLOW = "2"
}
